import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { columnsFromBackend } from './KanbanData';
import style from "./VendingMapping.module.css";
import MachineCard from "./MachineCard";
import { requester } from 'App';
import CustomButton from 'components/buttons/CustomButton';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Container from 'layouts/container/Container';
import Center from 'layouts/wrapper/Center';
import P from 'components/P';

const VendingMapping = () => {
    const { t } = useTranslation();
    const [columns, setColumns] = useState();
    const [isMounted, setMounted] = useState();
    const [machine, setMachine] = useState();
    useEffect(() => {
        requester.findAllStores((result) => {
            if (result.data) {
                const temp = result.data;
                const transformedData = {};
                transformedData["notRegistered"] = {
                    title: "미등록",
                    items: []
                };
                temp.forEach(item => {

                    transformedData[item.id] = {
                        title: item.storeName,
                        items: []
                    };
                });
                setColumns(transformedData);

            }

            setMounted(true);
        });
    }, []);
    useEffect(() => {
        if (isMounted) {
            requester.findAllVending((result) => {
                setMachine(result.data);
            })
        }
    }, [isMounted])
    useEffect(() => {
        if (machine) { // machine 데이터가 있을 경우
            const transformedData = {
                "notRegistered": {
                    "title": "미등록",
                    "items": []
                }
            };

            // 기존 columns 데이터를 transformedData에 복사
            Object.keys(columns).forEach(key => {
                if (key !== "notRegistered") { // notRegistered 제외하고 복사
                    transformedData[key] = {
                        ...columns[key],
                        items: [...columns[key].items] // 기존 아이템들을 복사
                    };
                }
            });

            // machine 데이터를 적절한 위치에 배치하고 orderNo로 정렬
            machine.forEach(m => {
                if (m.storeId && transformedData[m.storeId]) {
                    // 해당 storeId의 items 배열에 machine을 추가하고 orderNo로 정렬합니다.
                    transformedData[m.storeId].items.push(m);
                    transformedData[m.storeId].items.sort((a, b) => a.orderNo - b.orderNo);
                } else {
                    // storeId가 없는 경우, notRegistered에 추가하고 orderNo로 정렬합니다.
                    transformedData["notRegistered"].items.push(m);
                    transformedData["notRegistered"].items.sort((a, b) => a.orderNo - b.orderNo);
                }
            });

            setColumns(transformedData);
        }
    }, [machine]);
    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return;

        const sourceColumn = columns[source.droppableId];
        const destColumn = columns[destination.droppableId];
        const sourceItems = [...sourceColumn.items];
        const destItems = [...destColumn.items];
        const [removed] = sourceItems.splice(source.index, 1);

        // 이동한 머신의 storeId를 설정합니다.
        removed.storeId = destination.droppableId === "notRegistered" ? null : destination.droppableId;

        if (source.droppableId !== destination.droppableId) {
            // 다른 컬럼으로 이동한 경우
            destItems.splice(destination.index, 0, removed);
            // 목적지 컬럼의 아이템들 `orderNo` 재배열
            const newFinishItems = destItems.map((item, index) => ({
                ...item,
                orderNo: index + 1,
            }));

            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems.map((item, index) => ({
                        ...item,
                        orderNo: index + 1,
                    })),
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: newFinishItems,
                },
            });
        } else {
            // 같은 컬럼 내에서 이동한 경우
            sourceItems.splice(destination.index, 0, removed);
            // 소스 컬럼의 아이템들 `orderNo` 재배열
            const newItems = sourceItems.map((item, index) => ({
                ...item,
                orderNo: index + 1,
            }));

            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: newItems,
                },
            });
        }
    };

    const onUpdateClick = () => {
        const itemsToUpdate = Object.values(columns).flatMap(column => column.items.map(item => ({
            ...item,
            // 추가적인 변환 또는 서버에 필요한 데이터만 추출할 수 있습니다.
        })));


        // 서버 요청 로직 실행
        requester.updateVendingList(itemsToUpdate, (result) => {

            if (result.code === 0) {
                toast.success(t("수정되었습니다"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    }


    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>
                        기기매핑
                    </P>
                </Center>
                {
                    isMounted &&
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, columns, setColumns)}>
                        <div className={style.container}>
                            <div className={style.column}>
                                {Object.entries(columns).map(([columnId, column], index) => {
                                    return (
                                        <Droppable key={columnId} droppableId={columnId}>
                                            {(provided, snapshot) => (
                                                <div className={style.list}
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                >

                                                    <span className={style.title}>{column.title}</span>

                                                    {column.items.map((item, index) => (
                                                        <MachineCard key={item} item={item} index={index} />
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    );
                                })}
                            </div>
                        </div>
                    </DragDropContext>
                }
                <CustomButton text={"적용"} onClick={onUpdateClick} />
            </Container>
        </Container>
    );
}

export default VendingMapping;
